import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import './style.css';
import PersonalInformation from '../../../components/dashboardcomponents/Settings/PersonalInformation';
import Security from '../../../components/dashboardcomponents/Settings/Security';
import Notification from '../../../components/dashboardcomponents/Settings/Notification';
import WidgetSettings from '../../../components/dashboardcomponents/Settings/WidgetSettings';

const Settings = () => {
  const userData = useSelector((state) => state.loginToken);
  const isAdmin = userData?.response?.user?.role_name === "admin_with_billing" || userData?.response?.user?.role_name === "admin";

  const [activeTab, setActiveTab] = useState(isAdmin ? 4 : 2);

  // Memoized component rendering based on activeTab
  const registrationUIRender = useMemo(() => {
    return activeTab === 0 ? (
      <PersonalInformation />
    )
      : activeTab === 2 ? (
        <Notification />
      ) : activeTab === 4 ? (
        <WidgetSettings />
      ) : null;
  }, [activeTab]);

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const isTabActive = (tabIndex) => activeTab === tabIndex;

  return (
    <div className="Settings-main-container">

      <div className="Settings-Container001">
        <p className="Ticket-text">{'Settings'}</p>
        <div className="Ticket-main-header">
          <div className="Ticket-text-section">
            {(isAdmin) && (
              <>
                <p
                  className={`ticket-header-text ${isTabActive(0) ? 'TicketHeaderActive' : ''
                    }`}
                  onClick={() => handleTabClick(0)}
                >
                  {'Personal Information'}
                </p>

              </>
            )}
            {/* <p
              className={`ticket-header-text ${isTabActive(2) ? 'TicketHeaderActive' : ''
                }`}
              onClick={() => handleTabClick(2)}
            >
              {'Notification'}
            </p> */}
            {/* <p
              className={`ticket-header-text ${
                isTabActive(3) ? 'TicketHeaderActive' : ''
              }`}
              onClick={() => handleTabClick(3)}
            >
              {'Plans & Billing'}
            </p> */}
            {/* {(isAdmin) && (
              <p
                className={`ticket-header-text ${isTabActive(4) ? 'TicketHeaderActive' : ''
                  }`}
                onClick={() => handleTabClick(4)}
              >
                {'Widget'}
              </p>
            )} */}
            {/* <p
              className={`ticket-header-text ${
                isTabActive(5) ? 'TicketHeaderActive' : ''
              }`}
              onClick={() => handleTabClick(5)}
            >
              {'Plugins'}
            </p>
            <p
              className={`ticket-header-text ${
                isTabActive(6) ? 'TicketHeaderActive' : ''
              }`}
              onClick={() => handleTabClick(6)}
            >
              {'Data Export'}
            </p>
            <p
              className={`ticket-header-text ${
                isTabActive(7) ? 'TicketHeaderActive' : ''
              }`}
              onClick={() => handleTabClick(7)}
            >
              {'Sessions'}
            </p> */}
          </div>
        </div>
      </div>
      <div className="Settings-Main-Container">{registrationUIRender}</div>
    </div>
  );
};

export default Settings;
